import { useEffect } from 'react';
import type { DesktopBridge } from '@spawnwire/shared';
import { mentionCount, useStore, type AppState } from '../store/store';
import { navigate } from './nav';

/** The Windows app's bridge (apps/desktop), present only when this page runs inside it. */
export const desktop: DesktopBridge | null = typeof window !== 'undefined' ? ((window as unknown as { spawnwireDesktop?: DesktopBridge }).spawnwireDesktop ?? null) : null;

/** What the taskbar badge shows: the same mentions and friend requests the space rail badges add up. */
function waitingCount(s: AppState): number {
  let n = 0;
  for (const c of Object.values(s.channels)) {
    if (c.type === 'category' || c.type === 'voice' || c.type === 'stage') continue;
    n += mentionCount(s, c.id);
  }
  for (const r of Object.values(s.relationships)) if (r.type === 'incoming') n++;
  return n;
}

/** Inside the Windows app: keeps the taskbar badge current and opens conversations from notification clicks. */
export function useDesktopIntegration(): void {
  const count = useStore((s) => (desktop ? waitingCount(s) : 0));
  useEffect(() => {
    desktop?.setBadge(count);
  }, [count]);
  // Signed out (the shell unmounts): clear the badge.
  useEffect(() => () => desktop?.setBadge(0), []);
  useEffect(() => desktop?.onNavigate((path) => navigate(path)), []);
}
